import { request } from '@app/services';
/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * Root Reducer
 * combine all reducers to create root reducer
 */

import { combineReducers, type Action } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import Storage from "redux-persist/lib/storage";

import { bootstrapReducer } from "@app/modules/bootstrap";
import { commonReducer } from "@app/modules/common";
import { loginReducer, logout } from "@app/modules/auth";
import { dashboardReducer } from "@app/modules/dashboard";
import { salesPersonReducer } from "@app/modules/salesperson";
import { brandReducer } from "@app/modules/brand";
import { allProductReducer } from "@app/modules/product";
import { allCategoryReducer } from "@app/modules/category-page";
import { myProfileReducer } from "@app/modules/my-profile";
import { modelReducer } from "@app/modules/model";
import { requestReducer } from '@app/modules/requests';

/* -----[ persist configurations ]------ */
const rootPersistConfig = {
  key: "root",
  storage: Storage,
  whitelist: ["version", "commonReducer"],
};

const preserveAlways = ["bootstrapReducer"];

const stateVersion = 1; // Update it whenever change state structure of whitelist slice

const appReducer = combineReducers({
  bootstrapReducer,
  commonReducer,
  allCategoryReducer,
  allProductReducer,
  loginReducer,
  dashboardReducer,
  salesPersonReducer,
  brand: brandReducer,
  requestReducer,
  modelReducer,
  myProfileReducer,
  version: (state = stateVersion) => state,
});

const rootReducer = (
  state: ReturnType<typeof appReducer>,
  action: Action<any>
) => {
  if (action.type === logout.type) {
    const newState: any = Object.keys(state).reduce((acc, key) => {
      if (preserveAlways.includes(key)) {
        (acc as any)[key] = (state as any)[key];
      } else {
        (acc as any)[key] = undefined;
      }
      return acc;
    }, {});
    return appReducer(newState, action);
  }

  return appReducer(state, action);
};

const persistRootReducer = persistReducer(
  rootPersistConfig,
  (state, action) => {
    const migratedState = migrateState(state);
    return rootReducer(migratedState, action);
  }
);

const migrateState = (state: any) => {
  if (state !== undefined && state.version !== stateVersion) {
    return {
      ...state,
      version: stateVersion,
    };
  }

  return state;
};

export type RootState = ReturnType<typeof rootReducer>;

export { persistRootReducer };
